import makeStyles from '@mui/styles/makeStyles';
import NRHighchartTooltipStyles from './NRHighchartTooltip.styles';
const useStyles = makeStyles(NRHighchartTooltipStyles);
// muiTheme passed as parameter because somehow the correct theme got lost
function NRHighchartTooltip({ label, value, color, title = '', muiTheme }) {
  const classes = useStyles({ muiTheme });

  return (
    <>
      {!!title && <div className={classes.title}>{title}</div>}
      <div className={classes.tooltipContainer}>
        <svg height="13" width="13" className={classes.icon}>
          <circle cx="6" cy="6" r="6" fill={color} strokeWidth={1} />
        </svg>
        <div className={classes.labelContainer}>
          <span className={classes.label}>{`${label}: `}</span>
          <span className={classes.value}>{`${value}`}</span>
        </div>
      </div>
    </>
  );
}

export default NRHighchartTooltip;
